import React from "react";
import DisclosureCore from "../../../utils/disclosure/DisclosureCore";
import H3 from "../../../elements/titles/H3";
import Paragraph from "../../../elements/p/Paragraph";
import Container from "../../../utils/Container";

const StepsToPublishProduct = () => {
  return (
    <Container classe="mt-3">
      <DisclosureCore title="Étapes à suivre pour publier un produit">
        <Paragraph>
          Avant de publier une nouvelle catégorie ou un nouveau produit, vous
          devez au préalable travailler sur l'image de ce produit (catégorie)
          pour qu'elle soit bien présentée et qu'elle ne dégrade pas la vitesse
          de chargement de votre site. Pour cela, vous devez rogner,
          redimensionner, réduire le poids et détourer l'image.
        </Paragraph>
        <ul className="mt-3 flex flex-col space-y-4">
          <li>
            <H3>1. Rogner l'image</H3>
            <Paragraph>
              Vous pouvez rogner vos image sur{" "}
              <a
                href="https://watermarkly.com/fr/crop-photo/"
                target="_blank"
                rel="noreferrer"
                className="text-[#0070f3] hover:underline"
              >
                le site pour rogner les images
              </a>{" "}
            </Paragraph>
            <Paragraph>
              Rogner l'image vas vous permettre de bien recadrer la partie de
              l'image ou la photo est bien représentée.
            </Paragraph>
          </li>
          <li>
            <H3>2. Redimensionner l'image</H3>
            <Paragraph>
              Vous pouvez redimensionner vos image sur{" "}
              <a
                href="https://watermarkly.com/fr/photo-resizer/"
                target="_blank"
                rel="noreferrer"
                className="text-[#0070f3] hover:underline"
              >
                le site pour rédimenssionner les images
              </a>{" "}
            </Paragraph>
            <Paragraph>
              Rédimenssionner l'image permet de réduire ça taille. Depuis le
              site vous pouvez choisir par exemple 500px de largeur te la
              hauteur sera automatiquement calculé.
            </Paragraph>
          </li>
          <li>
            <H3>3. Compresser l'image</H3>
            <Paragraph>
              Vous pouvez compresser vos image sur{" "}
              <a
                href="https://watermarkly.com/fr/compress-jpeg/"
                target="_blank"
                rel="noreferrer"
                className="text-[#0070f3] hover:underline"
              >
                le site pour compresser les images
              </a>{" "}
            </Paragraph>
            <Paragraph>
              Compresser l'image permet de réduire ça poids et ainsi faire en
              sorte que votre site soit plus rapide en vitesse de chargement.
            </Paragraph>
          </li>
          <li>
            <H3>4. Détourer l'image</H3>
            <Paragraph>
              Vous pouvez détourer vos image sur{" "}
              <a
                href="https://www.remove.bg/fr"
                target="_blank"
                rel="noreferrer"
                className="text-[#0070f3] hover:underline"
              >
                le site pour détourer les images
              </a>{" "}
            </Paragraph>
            <Paragraph>
              Détourer une image consiste à enlever son arrière plan de telle
              sorte qu'il puisse bien s'adapter sur n'importe quel support.
            </Paragraph>
          </li>
        </ul>
      </DisclosureCore>
    </Container>
  );
};

export default StepsToPublishProduct;
